<template>
  <div class="qqService">
     <iframe class="innerHtml" frameborder="0" scrolling="auto" :src="url"></iframe>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: 'https://cdn.zxzx119.com/qq_service.html'
    }
  }
}
</script>

<style lang="scss" scoped>
.qqService{
  display: inline-block;
  width: 100%;
  height: 100vh;
  .innerHtml{
    display: inline-block;
    height: 100%;
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/app/qqservice.vue